import { getStationsLocale } from './getStationsLocale';
import { TUndergrounds } from './isSubwayAdded';

/**
 * Формирует строку со станциями метро.
 */
export function getSubwayStations(undergrounds: TUndergrounds) {
  if (undergrounds === null) {
    return '';
  }

  const stations = Object.keys(undergrounds).map(key => undergrounds[Number(key)].name);
  const head = stations.slice(0, 2); // Первые две станции метро добавляем в строку через запятую
  const tail = stations.slice(2); // Остальные станции формируем в зависимости от их количества
  const count = tail.length;
  let text = 'возле метро';

  text = text.concat(` ${head.join(', ')}`);

  if (count > 1) {
    text = text.concat(` и ещё ${count} ${getStationsLocale(count)}`);
  } else if (count === 1) {
    text = text.concat(` или ${tail[0]}`);
  }

  return text;
}
